export const getSupabaseCookieName = () => {
  const allCookies = document.cookie.split('; ')
  const allCookieNames = allCookies.map(cookie => cookie.split('=')[0])
  const supabaseCookieName = allCookieNames.find(
    cookieName =>
      cookieName.startsWith('sb-') && cookieName.endsWith('-auth-token'),
  )

  return supabaseCookieName?.split('=')[0]
}

export const removeSupabaseCookieAndToken = () => {
  const cookieName = getSupabaseCookieName()
  if (cookieName) {
    document.cookie = `${cookieName}=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/`
    window.localStorage.removeItem(cookieName)
  }
}
